import Mapa from '@componentes/Mapa/Mapa';
import { useEffect, useState } from 'react';
import instance from 'api/instance';
import { CoordinatesData, ParkingData } from '@componentes/Tabla/types';
import { obtenerParkingColor } from '@utils/parkingFunctions';
import { useWindowSize } from '@utils/resize';
import { fetchConfig } from 'api/configService';
import useToggle from '@utils/useToggle';
import TablaEspecial from '@componentes/TablaEspecial/TablaEspecial';
import { adjustDuplicateCoordinates } from '@utils/duplicateCoordinates';

export default function Aparcamientos() {
    const [parkings, setParkings] = useState<{ id: number, descripcion: string, direccion: string, libres: string, nivel: number }[]>([])
    const [allDataParkings, setAllDataParkings] = useState<ParkingData[]>([])
    const [coordinates, setCoordinates] = useState<CoordinatesData[]>([]);
    const [marked, setMarked] = useState('')
    const [coordinatesToGo, setCoordinatesToGo] = useState<CoordinatesData>({ lng: 0, lat: 0, id: 0 });
    const { width } = useWindowSize();
    const [configLoaded, setConfigLoaded] = useToggle(false);
    const [apiUrlConfig, setApiUrlConfig] = useState('');

    useEffect(() => {
        fetchConfig(setApiUrlConfig, setConfigLoaded);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (marked) {
            const value = allDataParkings.find(ele => ele.CODIGO === parseInt(marked));
            if (value) {
                setCoordinatesToGo({
                    lng: value.LONGITUD,
                    lat: value.LATITUD,
                    id: value.CODIGO,
                });
            }
        }
    }, [marked, allDataParkings]);

    useEffect(() => {
        if (configLoaded) {

            const fetchData = async () => {
                const apiUrl = `${apiUrlConfig}listadoParking`;
                instance
                    .get<ParkingData[]>(apiUrl)
                    .then((response) => {
                        const coordinates = response.data.filter(elem => elem.TOTALES !== null).map(ele => {
                            return {
                                id: ele.CODIGO,
                                lng: ele.LONGITUD,
                                lat: ele.LATITUD,
                                description: ele.DESCRIPCION,
                                image: ele.LIBRES === null ? 'privado' : obtenerParkingColor(ele.NIVEL),
                                direccion: ele.DIRECCION,
                                plazasLibres: ele.LIBRES,
                                plazasTotales: ele.TOTALES,
                                forzadura: ele.FORZADURA,
                                nivel: ele.NIVEL
                            }
                        }
                        )
                        setAllDataParkings(response.data)
                        setCoordinates(adjustDuplicateCoordinates(coordinates))
                        setParkings(response.data.map(ele => ({ id: ele.CODIGO, descripcion: ele.DESCRIPCION, direccion: ele.DIRECCION, libres: ele.LIBRES, nivel: ele.NIVEL, forzadura: ele.FORZADURA })))
                    })
                    .catch((error) => {
                        console.error("Error al hacer la solicitud:", error);
                    });
            };

            fetchData();
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configLoaded, apiUrlConfig]);

    return (
        <>
            {/* <h1>Aparcamientos</h1> */}
            {coordinates.length > 0 &&
                <div className="aparcamientos" style={{ display: 'flex', justifyContent: 'space-between', flexDirection: width > 1300 ? 'row' : 'column' }}>
                    <div style={{ width: width > 1300 ? '50%' : '100%', marginBottom: '20px' }}>
                        <TablaEspecial info={parkings} setMarked={setMarked} tipo='Aparcamientos' />
                    </div>
                    <div style={{ width: width > 1300 ? '48%' : '100%', marginBottom: '20px' }}>
                        <Mapa height={635} coordinates={coordinates} coordinatesToGo={coordinatesToGo} setMarked={setMarked}/>
                    </div>
                </div>}
        </>
    );
}